import { Territory } from "../models";

export const getDonorIsbtNumber = (donorNumber?: string, territory?: Territory) => {
    if (!donorNumber || !territory?.facilityIdentificationNumber) return;

    const hyphen = donorNumber.indexOf("-");
    const year = donorNumber.slice(1, hyphen);
    const sequence = year + donorNumber.slice(hyphen + 1);

    return `${territory.facilityIdentificationNumber} ${year} ${sequence}`;
};
